import { createContext, useState } from 'react';
import api from 'services/api';

export const DemonstracaoContext = createContext();

export const DemonstracaoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [demonstracao, setDemonstracao] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const getDemonstracao = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: demonstracao?.filter,
        page: demonstracao?.page,
        size: demonstracao?.size,
        order: demonstracao?.order,
        ...payload,
      });
      setDemonstracao((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <DemonstracaoContext.Provider
      value={{
        demonstracao,
        getLoading,
        getDemonstracao,
      }}
    >
      {children}
    </DemonstracaoContext.Provider>
  );
};
